
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/novedades/[[...product]]",
      function () {
        return require("private-next-pages/novedades/[[...product]].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/novedades/[[...product]]"])
      });
    }
  